<template>
    <div class="taplink-settings">
        <v-loading v-if="loading" />
        <template v-else>
            <v-form @submit="saveSettings">
                <section class="section">
                    <div class="section-title">Настройка страницы</div>
                    <div class="section-content">
                        <v-input
                            :disabled="!hasAccess"
                            name="page-title"
                            title="Название страницы"
                            v-model="pageSettings.title"
                        />
                    </div>
                </section>
                <section v-if="hasAccess" class="section">
                    <div class="section-title">
                        Настройка домена
                        <a
                            v-if="domainSettings.list.length && hasAccess"
                            @click.prevent="connectDomain"
                            href="javascript:void(0)"
                        >
                            Подключить
                        </a>
                    </div>
                    <div class="section-content">
                        <template v-if="domainSettings.list.length">
                            <div class="form-group">
                                <v-select
                                    :disabled="!hasAccess"
                                    title="Домен"
                                    name="domain"
                                    :options="domainSettings.list"
                                    v-model="domainSettings.selected"
                                />
                                <v-input
                                    :disabled="!hasAccess"
                                    title="Директория"
                                    name="folder"
                                    placeholder="folder-name"
                                    rules="required"
                                    v-model="domainSettings.folder"
                                    :static-placeholder="folderPlaceholder"
                                    @focusin="folderError = null"
                                    :error="folderError"
                                />
                            </div>
                        </template>
                        <template v-else>
                            <p>
                                У вас нет ни одного домена, для того чтобы разместить вашу страницу, нажмите на кнопку
                                ниже и привяжите ваш домен.
                            </p>
                            <v-button size="sm" @click="connectDomain">Подключить домен</v-button>
                        </template>
                    </div>
                </section>
                <hr class="separator" />
                <v-button v-if="hasAccess" type="submit" size="large">Сохранить</v-button>
            </v-form>
        </template>
    </div>
</template>

<script>
import VButton from "../../../../common/components/VButton";
import { api } from "../../services";

export default {
    name: "TaplinkLandingSettings",
    components: {
        VButton
    },
    props: {
        id: {}
    },
    data() {
        return {
            loading: false,
            domainSettings: null,
            pageSettings: null,
            folderError: null
        };
    },
    created() {
        this.load();
    },
    computed: {
        hasAccess() {
            return this.$user?.hasAccess("landing_builder_access");
        },
        selectedDomain() {
            return this.domainSettings.list.find(v => v.value === this.domainSettings.selected) || null;
        },
        folderPlaceholder() {
            return (this.selectedDomain?.label || "example.com") + "/";
        }
    },
    methods: {
        load() {
            this.loading = true;
            api.landing
                .get(this.id, "settings")
                .then(data => {
                    this.domainSettings = data.settings.domain;
                    this.pageSettings = data.settings.page;
                })
                .finally(() => (this.loading = false));
        },
        connectDomain() {
            this.openModal("DomainBinding", {
                id: this.$route.params.id
            }).then(domain => {
                this.domainSettings = domain;
                this.notify({ title: "Доменное имя привязано" });
            });
        },
        saveSettings() {
            const formData = {
                domain: {
                    id: this.domainSettings.selected,
                    folder: this.domainSettings.folder
                },
                page: this.pageSettings
            };
            api.landing
                .update(this.$route.params.id, { settings: formData }, "settings")
                .then(() => {
                    this.notify({ title: "Сохранено" });
                })
                .catch(({ data }) => {
                    this.folderError = Object.values(data.errors).toString();
                    this.notify({ title: "Ошибка", text: this.folderError, type: "error" });
                });
        }
    }
};
</script>

<style scoped lang="scss">
.taplink-settings {
    max-width: 400px;
    padding: 0 12px;
    .separator {
        border-color: #58606e;
    }
}
.section {
    margin-bottom: 25px;
    &-title {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        color: #000;
        margin-bottom: 24px;
        a {
            font-size: 16px;
        }
    }
    &-content {
        p {
            font-size: 14px;
            line-height: 24px;
            color: #58606e;
        }
        .form-group {
            max-width: 400px;
            margin-bottom: 20px;
        }
    }
}
</style>
